import { Route, Routes } from 'react-router-dom'

import CreateWaitingRoomPage from './waiting-room/CreateWaitingRoomPage'
import EstablishmentPage from './establishment/EstablishmentPage'
import EstablishmentsPage from './establishments/EstablishmentsPage'
import MeetingLinksPage from './meeting-links/MeetingLinksPage'
import StatisticsPage from './statistics/StatisticsPage'
import SettingsPage from './settings/SettingsPage'
import SubscriptionsPage from './subscriptions/SubscriptionsPage'
import WaitingRoomPage from './waiting-room/WaitingRoomPage'
import WaitingRoomsPage from './waiting-rooms/WaitingRoomsPage'

import ApiKeyPage from '@/pages/api-keys/ApiKeyPage'
import ApiKeysPage from '@/pages/api-keys/ApiKeysPage'
import CreateApiKeyPage from '@/pages/api-keys/CreateApiKeyPage'
import CreatePolicyPage from '@/pages/policies/CreatePolicyPage'
import NotFoundPage from '@/pages/error/NotFoundPage'
import PolicyPage from '@/pages/policies/PolicyPage'
import PoliciesPage from '@/pages/policies/PoliciesPage'
import LicensesPage from '@/pages/licenses/LicensesPage'
import CreateLicensePage from '@/pages/licenses/CreateLicensePage'
import LicensePage from '@/pages/licenses/LicensePage'
import ContractsPage from '@/pages/contracts/ContractsPage'
import CreateContractPage from '@/pages/contracts/CreateContractPage'
import ContractPage from '@/pages/contracts/ContractPage'
import MedicalActTemplatesPage from '@/pages/admin/medical-acts/MedicalActTemplatesPage'

import MedicalActRecordsPage from '@/pages/admin/medical-acts/MedicalActRecordsPage'
import DataExportPage from '@/pages/admin/data-export/DataExportPage'

export function SuperAdminPage() {
  return (
    <Routes>
      <Route index element={<EstablishmentsPage />} />
      <Route path="/api-keys" element={<ApiKeysPage />} />
      <Route path="/api-keys/create" element={<CreateApiKeyPage />} />
      <Route path="/api-keys/:apiKeyId" element={<ApiKeyPage />} />
      <Route path="/contracts" element={<ContractsPage />} />
      <Route path="/contracts/create" element={<CreateContractPage />} />
      <Route path="/contracts/:contractId" element={<ContractPage />} />
      <Route path="/establishments/:establishmentId" element={<EstablishmentPage />} />
      <Route path="/licenses" element={<LicensesPage />} />
      <Route path="/licenses/create" element={<CreateLicensePage />} />
      <Route path="/licenses/:licenseId" element={<LicensePage />} />
      <Route path="/meeting-links" element={<MeetingLinksPage />} />
      <Route path="/policies" element={<PoliciesPage />} />
      <Route path="/policies/create" element={<CreatePolicyPage />} />
      <Route path="/policies/:policyId" element={<PolicyPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/statistics" element={<StatisticsPage />} />
      <Route path="/subscriptions/:establishmentId" element={<SubscriptionsPage />} />
      <Route path="/waiting-rooms" element={<WaitingRoomsPage />} />
      <Route path="/waiting-rooms/create" element={<CreateWaitingRoomPage />} />
      <Route path="/waiting-rooms/:waitingRoomId" element={<WaitingRoomPage />} />
      <Route path="/medical-acts" element={<MedicalActTemplatesPage />} />
      <Route path="/medical-acts/records" element={<MedicalActRecordsPage />} />
      <Route path="/data-export" element={<DataExportPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default SuperAdminPage
